export const tierManageContentReduxKey = '@@tierManageContent';
export const tierListReduxKey = '@@tierList';
export const tierPopupReduxKey = '@@tierPopup';
export const actionKey = '@@tierCreator';
